import React from 'react';
import { HiOutlineUsers, HiOutlineUserGroup, HiOutlineArrowLeft } from 'react-icons/hi';
import { TabType, SearchMode } from '../../Resource/types';
import SearchControls from "./SearchControls";

interface TabBarProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  searchTerm: string;
  searchMode: SearchMode;
  onSearchTermChange: (term: string) => void;
  onSearchModeChange: (mode: SearchMode) => void;
  handleBackClick: () => void;
}

const TabBar: React.FC<TabBarProps> = ({ activeTab, onTabChange, searchTerm, searchMode, onSearchTermChange, onSearchModeChange, handleBackClick }) => (
  <div className="px-6 flex flex-row items-center justify-between w-full bg-light-surfacePrimary dark:bg-secondary-dark border-b border-light-border-default dark:border-gray-700 shadow-sm">
    <div className="py-4 flex items-center gap-4">
      {/* Back Button */}
      <button 
        onClick={handleBackClick}
        className="text-light-text-secondary dark:text-gray-400 hover:text-light-text-primary dark:hover:text-gray-300 transition-colors duration-200"
      >
        <HiOutlineArrowLeft className="w-5 h-5" />
      </button>
      <div className="relative inline-flex bg-tertiary-light dark:bg-tertiary-dark rounded-xl p-1 shadow-inner border border-light-border-subtle dark:border-gray-700/60">
        <div
          className={`absolute top-1 bottom-1 bg-primary-dark rounded-lg shadow-lg border border-light-border-emphasis dark:border-gray-600/40 transition-all duration-300 ease-in-out ${
            activeTab === TabType.PEOPLE ? 'left-1 w-[110px]' : 'left-[115px] w-[110px]'
          }`}
        />

        <button
          className={`relative z-10 px-4 py-3 text-sm font-semibold rounded-lg transition-all duration-300 ease-in-out min-w-[110px] flex items-center justify-center gap-2 ${
            activeTab === TabType.PEOPLE
              ? 'text-white shadow-sm'
              : 'text-light-text-tertiary dark:text-gray-400 hover:text-light-text-secondary dark:hover:text-gray-400'
          }`}
          onClick={() => onTabChange(TabType.PEOPLE)}
        >
          <HiOutlineUsers className="w-4 h-4" />
          People
        </button>

        <button
          className={`relative z-10 px-4 py-3 text-sm font-semibold rounded-lg transition-all duration-300 ease-in-out min-w-[110px] flex items-center justify-center gap-2 ${
            activeTab === TabType.TEAMS
              ? 'text-white shadow-sm'
              : 'text-light-text-tertiary dark:text-gray-400 hover:text-light-text-secondary dark:hover:text-gray-400'
          }`}
          onClick={() => onTabChange(TabType.TEAMS)}
        >
          <HiOutlineUserGroup className="w-4 h-4" />
          Teams
        </button>
      </div>
    </div>

    <SearchControls 
      searchTerm={searchTerm}
      searchMode={searchMode}
      onSearchTermChange={onSearchTermChange}
      onSearchModeChange={onSearchModeChange}
      activeTab={activeTab}
    />
  </div>
);

export default TabBar; 